import { Component, OnInit, Input, OnDestroy, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { Subscription} from 'rxjs';
import { AccountFilterService } from '../../services/accountfilter.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { initSessionName, sfdcAccountFilters } from '../../services/util.service';

const PREVIOUS_ICON = `
  <svg t="1626147426023" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4364" width="50" height="50"><path d="M687.978745 22.52096L227.234394 460.868016c-14.398261 12.798454-22.397295 31.996135-22.397294 51.193817s7.999034 38.395363 22.397294 51.193816L687.978745 1001.602705c22.397295 20.797488 52.793624 27.196715 81.590146 17.597875 27.196715-11.198647 47.994203-38.395363 49.594009-68.791692V75.314583C815.963287 44.918255 796.765606 17.72154 769.568891 6.522892c-28.796522-12.798454-60.792657-6.399227-81.590146 15.998068z" p-id="4365"></path></svg>
`;
const NEXT_ICON = `
  <svg t="1626150064893" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3041" width="50" height="50"><path d="M336.102762 1001.015188l460.53095-438.144028c14.391592-12.792526 22.386921-31.981316 22.386921-51.170105 0-19.18879-7.995329-38.377579-22.386921-51.170106L336.102762 22.386921C313.715841 1.599066 283.333591-4.797197 254.550407 4.797197c-27.184119 11.193461-47.971974 38.377579-49.57104 68.75983v876.288056c3.198132 30.38225 22.386921 57.566369 49.57104 68.759829 28.783184 11.193461 60.7645 4.797197 81.552355-17.589724z" p-id="3042"></path></svg>
`;

const equalsIgnoreOrder = (a: string[], b: string[]) => {
  if (a.length !== b.length) return false;
  const uniqueValues = new Set([...a, ...b]);
  for (const v of uniqueValues) {
    const aCount = a.filter(e => e === v).length;
    const bCount = b.filter(e => e === v).length;
    if (aCount !== bCount) return false;
  }
  return true;
};

@Component({
  selector: 'app-account-filtering',
  templateUrl: './account-filtering.component.html',
  styleUrls: ['./account-filtering.component.scss']
})
export class AccountFilteringComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() showRestrictedFilter: boolean;
  @Input() isAdmin: boolean;
  @Input() clearSession: boolean;
  @Output() resetSessionFlag = new EventEmitter<any>();
  private accountResults$: Subscription;
  private accountFilter$: Subscription;
  private lastAccounts$: Subscription;
  accountResults:any;
  lastAccounts: any[] = [];
  allVisitedAccounts: any[] = [];
  accountPlaceHolders: number[] = [];
  showLastAccounts: boolean = false;

  constructor(
    private accountFilterService: AccountFilterService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {
    this.iconRegistry.addSvgIconLiteral('previous-icon', this.sanitizer.bypassSecurityTrustHtml(PREVIOUS_ICON));
    this.iconRegistry.addSvgIconLiteral('next-icon', this.sanitizer.bypassSecurityTrustHtml(NEXT_ICON));
  }

  data: any = {
    region: '',
    accountType: '',
    technology: '',
    offeringLayer: '',
    serviceTenure: '',
    status: '',
    salesOrgL2: '',
    restricted: '',
    accountName: '',
    provider: '',
    code: '',
    sfdcglobalid: '',
    accountID: '',
    casesafeid: ''
  };
  regions: any[] = [];
  accountTypes: any[] = [];
  technologies: any[] = [];
  offeringLayers: any[] = [];
  serviceTenures: any[] = [
    {
      tenureofservice: '0',
      value: 0,
      op: 'eq'
    },
    {
      tenureofservice: '1',
      value: 1,
      op: 'eq'
    },
    {
      tenureofservice: '2',
      value: 2,
      op: 'eq'
    },
    {
      tenureofservice: '3',
      value: 3,
      op: 'eq'
    },
    {
      tenureofservice: '4',
      value: 4,
      op: 'eq'
    },
    {
      tenureofservice: '5-10',
      from: 5,
      to: 10,
      op: 'range'
    },
    {
      tenureofservice: '11-20',
      from: 11,
      to: 20,
      op: 'range'
    },
    {
      tenureofservice: '21+',
      value: 21,
      op: 'ge'
    },
  ];
  statuses: any[] = [];
  salesOrgL2s: any[] = [];
  restrictList: any[] = [
    {
      restrict: 'Yes'
    }
  ];
  providerList: any[] = [];
  isLoading = true;
  loading = false;
  disablePrevious: boolean = true;
  disableNext: boolean = true;
  currentIndex: number = 0;
  totalCount: number = 0;
  size: number = 5;
  searchFilter = {
    filterBy: '',
    pageSize: 20000,
    pageIndex: 1
  }
  pageLength:any;
  hasFilter: boolean = false;

  filterConfigs: any[] = [];
  isOpen: boolean = false;
  filterList: any[] = [
    {
      name: 'Region',
      value: 'region',
      order: 1
    },
    {
      name: 'Sales Org L2',
      value: 'salesOrgL2',
      order: 2
    },
    {
      name: 'Account Type',
      value: 'accountType',
      order: 3
    },
    {
      name: 'Account Name',
      value: 'accountName',
      order: 5
    },
    {
      name: 'Stack Layer / Area',
      value: 'offeringLayer',
      order: 6
    },
    {
      name: 'Technology',
      value: 'technology',
      order: 8
    },
    {
      name: 'Entity Status',
      value: 'status',
      order: 4
    },
    {
      name: 'Service Tenure',
      value: 'serviceTenure',
      order: 7
    },
    {
      name: 'Restricted',
      value: 'restricted',
      order: 10
    },
    {
      name: 'Provider',
      value: 'provider',
      order: 9
    },
    {
      name: 'Client Code',
      value: 'code',
      order: 11,
      adminOnly: true
    },
    {
      name: 'SFDC Global ID',
      value: 'sfdcglobalid',
      order: 12,
      adminOnly: true
    },
    {
      name: 'Account ID',
      value: 'accountID',
      order: 13,
      adminOnly: true
    },
    {
      name: 'Case Safe ID',
      value: 'casesafeid',
      order: 14,
      adminOnly: true
    }
  ];
  currentFilterList: any[] = [];
  selectedFilters: string[] = [];
  filters: any[] = [];
  tempSelectedFilters: string[] = [];
  fromEstateMap = true;

  entitiesTableDef = {
    title:"Entities",
    tableName:"Entities",
    pagedOn:true,
    filterOn:false,
    sortOn:true,
    fields:[
      { name: "logo",
        label: "Logos",
        width: "70px",
        type: "dropdown",
        align: "center",
        logo:"show",
        hideHeader: true,
        hideFilter: true,
        hasBorder: true,
        matTooltipClass: 'capitalize-tooltip'
      },
      { name: "name",
        label: "Account Name",
        type: "string",
        goto: true,
        showIconBefore: true,
        iconField: {
          field: 'restricted',
          value: 'Yes',
          icon: 'lock',
          iconTitle: 'Restricted'
        },
      },
      {
        name: "region",
        label: "Region",
        type: "string",
        width: "120px",
      },
      {
        name: "salesOrgL2",
        label: "Sales Org L2",
        type: "string",
        width: "200px",
      },
      { 
        name: "clientclass",
        label: "Account Status",
        type: "string",
        width: "200px",
      },
    ]
  }

  sessionName = '';
  currentFilters: any = {};

  ngOnInit(): void {
    this.getFilterSession();
    this.filterConfigs = [
      {
        title: 'Region',
        type: 'select',
        bindValue: 'name',
        bindLabel: 'name',
        fieldName: 'region',
        listName: 'regions',
        disabled: () => false,
        groupBy: '',
        selectableGroup: false,
        selectableGroupAsModel: false,
        change: (event) => {
          return this.updateRegion(event);
        }
      },
      {
        title: 'Sales Org L2',
        type: 'select',
        bindValue: 'name',
        bindLabel: 'name',
        fieldName: 'salesOrgL2',
        listName: 'salesOrgL2s',
        disabled: () => {
          return this.disableSalesOrgL2Select();
        },
        groupBy: '',
        selectableGroup: false,
        selectableGroupAsModel: false,
        change: (event) => {
          return this.updateField(event);
        }
      },
      {
        title: 'Account Type',
        type: 'select',
        bindValue: 'name',
        bindLabel: 'name',
        fieldName: 'accountType',
        listName: 'accountTypes',
        disabled: () => false,
        groupBy: '',
        selectableGroup: false,
        selectableGroupAsModel: false,
        change: (event) => {
          return this.updateField(event);
        }
      },
      {
        title: 'Account Name',
        type: 'input',
        fieldName: 'accountName'
      },
      {
        title: 'Stack Layer / Area',
        type: 'select',
        bindValue: 'area',
        bindLabel: 'area',
        fieldName: 'offeringLayer',
        listName: 'offeringLayers',
        disabled: () => false,
        groupBy: (item) => {
          return this.groupByFn(item);
        },
        selectableGroup: true,
        selectableGroupAsModel: false,
        change: (event) => {
          return this.updateField(event);
        }
      },
      {
        title: 'Technology',
        type: 'select',
        bindValue: 'technology',
        bindLabel: 'technology',
        fieldName: 'technology',
        listName: 'technologies',
        disabled: () => false,
        groupBy: '',
        selectableGroup: false,
        selectableGroupAsModel: false,
        change: (event) => {
          return this.updateField(event);
        }
      },
      {
        title: 'Entity Status',
        type: 'select',
        bindValue: 'name',
        bindLabel: 'name',
        fieldName: 'status',
        listName: 'statuses',
        disabled: () => false,
        groupBy: '',
        selectableGroup: false,
        selectableGroupAsModel: false,
        change: (event) => {
          return this.updateField(event);
        }
      },
      {
        title: 'Service Tenure',
        type: 'select',
        bindValue: 'tenureofservice',
        bindLabel: 'tenureofservice',
        fieldName: 'serviceTenure',
        listName: 'serviceTenures',
        disabled: () => false,
        groupBy: '',
        selectableGroup: false,
        selectableGroupAsModel: false,
        change: (event) => {
          return this.updateField(event);
        }
      },
      {
        title: 'Restricted',
        type: 'select',
        bindValue: 'restrict',
        bindLabel: 'restrict',
        fieldName: 'restricted',
        listName: 'restrictList',
        disabled: () => false,
        groupBy: '',
        selectableGroup: false,
        selectableGroupAsModel: false,
        change: (event) => {
          return this.updateField(event);
        }
      },
      {
        title: 'Provider',
        type: 'select',
        bindValue: 'provider',
        bindLabel: 'provider',
        fieldName: 'provider',
        listName: 'providerList',
        disabled: () => false,
        groupBy: '',
        selectableGroup: false,
        selectableGroupAsModel: false,
        change: (event) => {
          return this.updateField(event);
        }
      },
      {
        title: 'Client Code',
        type: 'input',
        fieldName: 'code'
      },
      {
        title: 'SFDC Global ID',
        type: 'input',
        fieldName: 'sfdcglobalid'
      },
      {
        title: 'Account ID',
        type: 'input',
        fieldName: 'accountID'
      },
      {
        title: 'Case Safe ID',
        type: 'input',
        fieldName: 'casesafeid'
      }
    ];

    this.initFilters();
    for (const key in this.currentFilters) {
      if (this.data.hasOwnProperty(key) && this.currentFilters[key]) {
        this.data[key] = JSON.parse(JSON.stringify(this.currentFilters[key]));
      }
    }
    if (Array.isArray(this.currentFilters.selectedFilters) && this.currentFilters.selectedFilters.length) {
      this.selectedFilters = JSON.parse(JSON.stringify(this.currentFilters.selectedFilters));
      this.tempSelectedFilters = [...this.selectedFilters];
    }
    
    this.resetOverlayList();
    this.setFilter();
    
    this.lastAccounts$ = this.accountFilterService.lastAccounts$.subscribe(
      (res: any) => {
        if(res){
          const { loading, data } = res;
          if (loading){
            this.showLastAccounts = false;
          } else {
            this.allVisitedAccounts = JSON.parse(JSON.stringify(data || []));
            this.totalCount = this.allVisitedAccounts.length;
            this.currentIndex = 0;
            this.setLastAccounts();
            this.showLastAccounts = true;
          }
        }
      }
    );
    this.accountFilterService.getLastAccounts();

    this.accountResults$ = this.accountFilterService.accountResults$.subscribe(
      (responsedata: any) => {
        if(responsedata){
          if(responsedata.loading){
            this.isLoading = true;
          } else {
            let results = responsedata["data"].data[0]["dataitems"];
            this.accountResults = JSON.parse(results) || [];
            this.pageLength = responsedata["data"].data[0]["totalrecords"];
            this.isLoading = false;
          }
        }
      }
    );
    
    this.accountFilterService.loadAllAccountsFiltering();

    this.accountFilter$ = this.accountFilterService.allAccountFilters$.subscribe(
      (responsedata: any) => {
        if(responsedata!=null){
          if(responsedata.loading){
          } else {
            let data = responsedata['data'];
            if (Array.isArray(data) && data.length) {
              const filterData = data[0];
              Object.keys(filterData).forEach(key => {
                const items = JSON.parse(filterData[key]);
                if (Array.isArray(items)) {
                  if (key === 'regions') {
                    this.regions = items;
                    this.regionChange();
                  } else if (key === 'accounttypes') {
                    this.accountTypes = items;
                  } else if (key === 'servicestatus') {
                    this.statuses = items;
                  } else if (key === 'technologies') {
                    this.technologies = items;
                  } else if (key === 'offeringlayers') {
                    this.offeringLayers = items;
                  } else if (key === 'prividers') {
                    this.providerList = items;
                  }
                }
              });
            }
          }
        }
      }
    )

    this.search();

    if (this.clearSession) {
      this.fromEstateMap = false;
      this.clearFilters();
    }
  }

  ngAfterViewInit(): void {
    document.addEventListener('click', this.clickEvent);
  }

  ngOnDestroy(): void {
    this.accountResults$.unsubscribe();
    this.accountFilter$.unsubscribe();
    this.lastAccounts$.unsubscribe();
    document.removeEventListener('click', this.clickEvent);
  }

  clickEvent: any = (event: any) => {
    event.stopPropagation();
    if (event.target) {
      let hideOverlay = true;
      const excludeIds = ['triggerFilterOverlayButton', 'filterOverlay'];
      excludeIds.forEach(id => {
        const parentSelector = document.getElementById(id);
        if (event.target.id === id || this.checkParentBySelector(event.target, parentSelector)) {
          hideOverlay = false;
        }
      });
      if (hideOverlay) {
        this.hideOverlay();
        this.resetOverlayList();
      }
    }
  };

  checkParentBySelector(el, parentSelector) {
    let hasParentSelector = false;
    let p = el.parentNode;
    while (p && p !== parentSelector && p !== document.body) {
      p = p.parentNode;
    }
    if (p === parentSelector) {
      hasParentSelector = true;
    }
    return hasParentSelector;
  }

  groupByFn = item => item.framename || 'Rest of Items';

  generateFilterCondition(filterBy, arr, key) {
    if (arr.length > 0) {
      let op = null;
      let value = null;
      let valueKey = null;
      if (arr.length > 1) {
        op = 'in';
        value = arr;
        valueKey = 'values';
      } else {
        op = 'eq';
        value =  arr[0];
        valueKey = 'value';
      }
      filterBy.push({
        key,
        [valueKey]: value,
        op
      });
    }
  }

  generateCondition(filterBy, dataKey, key) {
    this.generateFilterCondition(filterBy, this.data[dataKey], key);
  }

  generateInputFilterCondition(filterBy: any[], dataKey: string, key: string) {
    const value = (this.data[dataKey] || '').trim();
    this.data[dataKey] = value;
    if (value) {
      filterBy.push({
        key,
        value,
        op: 'eq'
      });
    }
  }

  updateField(event) {
    const { field, value } = event;
    this.data[field] = value;
  }

  filterAccounts() {
    this.search();
  }

  search() {
    let filterBy = [];
    this.generateCondition(filterBy, 'region', 'Region');
    this.generateCondition(filterBy, 'accountType', 'clientclass');
    this.generateCondition(filterBy, 'technology', 'technology');
    this.generateCondition(filterBy, 'status', 'status');
    this.generateCondition(filterBy, 'salesOrgL2', 'salesOrgL2');
    this.generateCondition(filterBy, 'restricted', 'restricted');
    this.generateCondition(filterBy, 'offeringLayer', 'area');
    this.generateCondition(filterBy, 'provider', 'provider');
    sfdcAccountFilters.forEach(key => this.generateInputFilterCondition(filterBy, key, key));

    const accountName = this.data['accountName'].trim();
    this.data['accountName'] = accountName;
    if (accountName.length > 0) {
      let values = [];
      const keys = ['name', 'short'];
      const op = 'like';
      keys.forEach(key => {
        values.push({
          key,
          value: accountName,
          op
        });
      });

      if (values.length > 0) {
        filterBy.push({
          op: 'or',
          values: values
        });
      }
    }

    if (this.data['serviceTenure'].length > 0) {
      let values = [];
      const key = 'servicetenure';
      this.data['serviceTenure'].forEach(tenure => {
        const item = this.serviceTenures.find(itm => itm.tenureofservice === tenure);
        if (item) {
          const { value, from, to, op } = item;
          if (op === 'eq') {
            const { startDate, endDate } = this.getRangeDate(value, value);
            values.push({
              key,
              value: startDate,
              value1: endDate,
              op: 'range'
            });
          } else if (op === 'range') {
            const { startDate, endDate } = this.getRangeDate(from, to);
            values.push({
              key,
              value: startDate,
              value1: endDate,
              op
            });
          } else if (op === 'ge') {
            const { endDate } = this.getRangeDate(value, value);
            values.push({
              key,
              value: endDate,
              op: 'le'
            });
          }
        }
      });

      if (values.length > 0) {
        filterBy.push({
          op: 'or',
          values: values
        });
      }
    }
    
    this.searchFilter.filterBy = JSON.stringify(filterBy)
    this.accountFilterService.loadAccountsdashboard(this.searchFilter);
    this.setFilterSession();

    this.checkFilter();
  }

  getRangeDate(from: number, to: number) {
    const currentYear = (new Date()).getFullYear();
    return {
      startDate: `${currentYear - to}-01-01`,
      endDate: `${currentYear - from}-12-31`
    }
  }

  reset() {
    this.resetFilters();
    this.fromEstateMap = true;
    this.search();
  }

  resetFilters() {
    Object.keys(this.data).forEach(key => {
      this.data[key] = '';
    });
    this.salesOrgL2s = [];
    this.initFilters();
    this.resetOverlayList();
    this.setFilter();
  }

  clearFilters() {
    this.resetFilters();
    this.clearFilterSession();
    this.checkFilter();
    this.resetSessionFlag.emit();
  }

  updateRegion(event) {
    this.updateField(event);
    this.regionChange();
  }

  regionChange() {
    if(this.data['region'].length > 0) {
      let salesOrgL2Values = [];
      let salesOrgL2s = [];
      this.data['region'].forEach(region => {
        this.regions.forEach(item => {
          if(item.name === region && Array.isArray(item.subregions)) {
            item.subregions.forEach(sr => {
              const { name } = sr;
              if (!salesOrgL2Values.includes(name)) {
                salesOrgL2Values.push(name);
                salesOrgL2s.push(sr);
              }
            });
          }
        });
      });
      const selectedSalesOrgL2s = salesOrgL2Values.filter(itm => (this.data['salesOrgL2'] || []).includes(itm));
      this.salesOrgL2s = salesOrgL2s;
      this.data['salesOrgL2'] = selectedSalesOrgL2s;
    } else {
      this.data['salesOrgL2'] = [];
      this.salesOrgL2s = [];
    }
  }

  setLastAccounts() {
    const lastAccounts = this.allVisitedAccounts.slice(this.currentIndex, this.currentIndex + this.size);
    let placeHolders = [];
    for (let i = lastAccounts.length; i < this.size; i++) {
      placeHolders.push(i);
    }
    this.lastAccounts = lastAccounts;
    this.accountPlaceHolders = placeHolders;
    
    if (this.currentIndex > 0) {
      this.disablePrevious = false;
    } else {
      this.disablePrevious = true;
    }
    if (this.totalCount > (this.currentIndex + 5)) {
      this.disableNext = false;
    } else {
      this.disableNext = true;
    }
  }

  getPrevAccounts() {
    if (!this.disablePrevious) {
      this.currentIndex--;
      this.setLastAccounts();
    }
  }
  
  getNextAccounts() {
    if (!this.disableNext) {
      this.currentIndex++;
      this.setLastAccounts();
    }
  }

  redirect(element) {
    let o = {};    
    o['a'] = element.accountid;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: o,
      queryParamsHandling: 'merge',
      skipLocationChange: false,
      replaceUrl: false
    });
  }

  getName(account) {
    const { short, name } = account;
    let result = '';
    if (short) {
      const str = name || '';
      if (str.length > 30) {
        result = short;
      } else {
        result = name;
      }
    } else {
      result = name;
    }
    return result || '';
  }

  checkFilter() {
    let hasFilter = false;
    for (let key in this.data) {
      if (this.data.hasOwnProperty(key)) {
        if (this.data[key].length > 0) {
          hasFilter = true;
        }
      }
    }

    this.hasFilter = hasFilter;
  }

  disableSalesOrgL2Select() {
    return this.data['region'].length === 0;
  }

  initFilters() {
    this.filters = [];
    this.selectedFilters = this.clearSession ? [] : [
      'accountType',
      'region',
      'salesOrgL2',
      'status'
    ];
    this.tempSelectedFilters = [...this.selectedFilters];
    this.currentFilterList = this.filterList.filter(itm => {
      if (this.isAdmin) {
        return itm;
      } else {
        return !itm.adminOnly;
      }
    }).filter(itm => {
      if (this.showRestrictedFilter) {
        return itm;
      } else {
        return itm.value !== 'restricted';
      }
    }).sort((l, r) => {
      return l.order - r.order;
    }).map(itm => {
      return {
        ...itm,
        checked: this.selectedFilters.includes(itm.value),
        disable: itm.value === 'salesOrgL2'
      }
    });
  }

  toggleOverlay() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.tempSelectedFilters = [...this.selectedFilters];
    } else {
      this.resetOverlayList();
    }
  }

  hideOverlay() {
    this.isOpen = false;
  }

  setFilter() {
    if (!this.clearSession) {
      this.selectedFilters = this.selectedFilters.filter(itm => this.currentFilterList.find(item => item.value === itm));
    }
    this.selectedFilters.sort((l, r) => {
      const lItem = this.currentFilterList.find(item => item.value === l) || {};
      const rItem = this.currentFilterList.find(item => item.value === r) || {};
      return lItem.order - rItem.order;
    });
    this.tempSelectedFilters = [...this.selectedFilters];
    this.hideOverlay();
    let filters = [];
    this.selectedFilters.forEach(selectedFilter => {
      const item = this.filterConfigs.find(itm => itm.fieldName === selectedFilter);
      const length = filters.length;
      if (length) {
        const lastLength = filters[length - 1].length;
        if (lastLength === 2) {
          filters.push([
            item
          ]);
        } else {
          filters[length - 1].push(item);
        }
      } else {
        filters.push([
          item
        ]);
      }
    });
    this.filters = filters;

    Object.keys(this.data).forEach(key => {
      if (!this.selectedFilters.includes(key)) {
        this.data[key] = '';
      }
    });
    this.setFilterSession();
  }

  resetOverlayList() {
    this.selectedFilters = [...this.tempSelectedFilters];
    this.currentFilterList.forEach(itm => {
      if (this.selectedFilters.includes(itm.value)) {
        itm.checked = true;
      } else {
        itm.checked = false;
      }
    });
    this.setSalesOrgL2Status();
  }

  updateSelectedFilters(event) {
    const { checked, source: { value } } = event;
    if (checked) {
      if (!this.selectedFilters.includes(value)) {
        this.selectedFilters.push(value);
      }
    } else {
      const index = this.selectedFilters.indexOf(value);
      if (index > -1) {
        this.selectedFilters.splice(index, 1);
      }
    }

    if (value === 'region') {
      this.setSalesOrgL2Status();
    }
  }

  setSalesOrgL2Status() {
    const item = this.currentFilterList.find(itm => itm.value === 'salesOrgL2');
    if (item) {
      if (this.selectedFilters.includes('region')) {
        item.disable = false;
      } else {
        item.checked = false;
        item.disable = true;
        const idx = this.selectedFilters.indexOf('salesOrgL2');
        if (idx > -1) {
          this.selectedFilters.splice(idx, 1);
        }
      }
    }
  }

  disableSetFilterButton() {
    return equalsIgnoreOrder(this.selectedFilters, this.tempSelectedFilters);
  }

  showSubmitButton() {
    return this.filters.length > 0 || this.hasFilter;
  }

  getFilterSession() {
    this.sessionName = initSessionName();
    const session = window.sessionStorage.getItem(this.sessionName);
    if (session) {
      this.currentFilters = JSON.parse(session);
    } else {
      this.currentFilters = {};
    }
  }

  setFilterSession() {
    const data = JSON.parse(JSON.stringify(this.data));
    const filters = {
      ...data,
      selectedFilters: JSON.parse(JSON.stringify(this.selectedFilters))
    };
    window.sessionStorage.setItem(this.sessionName, JSON.stringify(filters));
  }

  clearFilterSession() {
    window.sessionStorage.removeItem(this.sessionName);
  }
}
